<template>
  <div class="box">
    <div class="top-title"><span></span>单据类型</div>
    <div style="padding: 20px">
      <base-form
        v-model="baseData"
        :options="baseDataOptions"
        ref="baseData"
        @input="handleChangeBaseData"
        label-width="105px"
      ></base-form>
    </div>
    <div class="top-title"><span></span>操作类型</div>
    <div style="padding: 20px">
      <vxe-toolbar size="mini">
        <template v-slot:buttons>
          <div style="padding-bottom: 10px">
            <vxe-button size="medium" type="primary" class="vxe-btn-save" @click="addRow">
              <svg-icon
                class="icon-img"
                style="font-size: 16px; padding-right: 6px"
                icon-class="icon-add"
              />
              {{ $t('credit.btnList.add') }}
            </vxe-button>
            <vxe-button size="medium" type="primary" class="vxe-btn-delete" @click="removeSelected">
              <svg-icon
                class="icon-img"
                style="font-size: 16px; padding-right: 6px"
                icon-class="icon-white-delete"
              />
              {{ $t('credit.btnList.del') }}
            </vxe-button>
          </div>
        </template>
      </vxe-toolbar>
      <vxe-table
        border
        show-overflow
        resizable
        ref="xGrid"
        class="vxe-table-element"
        size="mini"
        align="left"
        :auto-resize="true"
        :edit-rules="editRules"
        :data="tableData"
        :edit-config="{ trigger: 'click', mode: 'row', showStatus: true }"
        :checkbox-config="{ labelField: 'name' }"
        :valid-config="{ autoPos: true, showMessage: true }"
      >
        <vxe-table-column type="checkbox" width="60" fixed="left"></vxe-table-column>
        <vxe-table-column
          type="index"
          width="60"
          :title="$t('table.index')"
          fixed="left"
        ></vxe-table-column>
        <vxe-table-column field="billType" title="单据配置表id" :edit-render="{ name: 'input' }">
          <template v-slot:edit="{ row }"
            ><el-input v-model="row.billType" :disabled="true"
          /></template>
        </vxe-table-column>
        <vxe-table-column
          field="operateType"
          title="操作类型编码"
          :edit-render="{ name: 'input', immediate: true }"
        ></vxe-table-column>
        <vxe-table-column
          field="operateTypeName"
          title="操作类型名称"
          :edit-render="{ name: 'input', immediate: true }"
        ></vxe-table-column>
        <vxe-table-column field="enable" title="是否启用" :edit-render="{ name: 'input' }">
          <template v-slot:default="{ row }">
            {{ row.enable ? '是' : '否' }}
          </template>
          <template v-slot:edit="{ row }">
            <el-select v-model="row.enable">
              <el-option label="是" :value="1"></el-option>
              <el-option label="否" :value="0"></el-option>
            </el-select>
          </template>
        </vxe-table-column>
      </vxe-table>
    </div>
    <div class="bottom-button">
      <vxe-button size="medium" type="primary" class="vxe-btn-save" @click="save()">
        <svg-icon
          class="icon-img"
          style="font-size: 16px; padding-right: 6px"
          icon-class="icon-preserve"
        />
        {{ $t('credit.btnList.save') }}
      </vxe-button>
    </div>
  </div>
</template>

<script>
  import baseForm from '@/components/form/base-form';
  export default {
    name: 'edit',
    components: {
      baseForm,
    },
    data() {
      return {
        baseData: {
          billType: null,
          billTypeName: null,
          route: null,
          enable: true,
        },
        tableData: [],
      };
    },
    computed: {
      baseDataOptions() {
        return [
          {
            type: 'input',
            label: '单据类型编码',
            prop: 'billType',
            required: true,
            disabled: this.$route.query?.id ? true : false,
          },
          {
            type: 'input',
            label: '单据类型名称',
            prop: 'billTypeName',
            required: true,
          },
          {
            type: 'input',
            label: '路由',
            prop: 'route',
            required: true,
          },
          {
            type: 'checkbox',
            label: '是否启用',
            prop: 'enable',
            required: true,
          },
        ];
      },
      editRules() {
        return {
          operateType: [{ required: true, message: '请输入操作类型编码' }],
          operateTypeName: [{ required: true, message: '请输入操作类型名称' }],
          enable: [{ required: true, message: '请选择是否启用' }],
        };
      },
    },
    mounted() {
      if (this.$route.query?.id) {
        this.loadData();
      }
    },
    methods: {
      loadData() {
        this.$axios
          .post('/component/approvalBillType/queryById', { id: this.$route.query.id })
          .then((res) => {
            this.baseData = res.data.data;
            this.tableData = this.baseData.operateTypeList;
          })
          .catch((err) => {
            this.$message({
              showClose: true,
              message: err.data.msg,
              type: 'error',
            });
          });
      },
      handleChangeBaseData() {},
      addRow() {
        let obj = {
          billType: null,
          operateType: '',
          enable: 1,
          operateTypeName: '',
        };
        this.tableData.push(obj);
      },
      save() {
        const errMap = this.$refs.xGrid.validate();
        const baseData = this.$refs.baseData.handleSubmit();
        Promise.all([errMap, baseData])
          .then(() => {
            let params = {
              ...this.baseData,
              enable: this.baseData.enable ? 1 : 0,
              operateTypeList: this.tableData,
            };
            this.$axios.post('/component/approvalBillType/save', params).then((res) => {
              this.dblclickEvent();
              this.$message({
                showClose: true,
                message: res.data.msg,
                type: 'success',
              });
            });
          })
          .catch((err) => {
            this.$message({
              showClose: true,
              message: err.data.msg,
              type: 'error',
            });
          });
      },
      removeSelected() {
        let data = this.$refs.xGrid.getSelectRecords();
        if (data && data.length > 0) {
          this.load = true;
          this.$confirmAction()
            .then(() => {
              this.$refs.xGrid.removeSelecteds();
              this.tableData = this.$refs.xGrid.getTableData().fullData;
              this.load = false;
            })
            .catch(() => {
              this.load = false;
              this.$message({
                type: 'info',
                message: this.$t('confirm.deleteCancelled'),
              });
            });
        } else {
          this.$message({
            showClose: true,
            message: this.$t('applicationCredit.msg.delSelectedModify'),
            type: 'error',
          });
        }
      },
      dblclickEvent() {
        let path = {
          fromPath: {
            path: this.$route.query?.id
              ? '/todoCenter/billConfigEdit'
              : '/todoCenter/billConfigAdd',
            name: this.$route.query?.id ? 'billConfigEdit' : 'billConfigAdd',
            meta: {
              keepAlive: true,
              title: this.$route.query?.id ? '单据配置编辑' : '单据配置新增',
            },
          },
          toPath: {
            path: '/todoCenter/billConfig',
            name: 'billConfig',
            meta: {
              keepAlive: false,
              title: '单据配置',
            },
            query: {},
          },
        };
        this.$store.dispatch('tagsView/backTabView', path).then(() => {
          this.$nextTick(() => {
            this.$router.push(path.toPath);
          });
        });
      },
    },
  };
</script>

<style scoped lang="scss">
  .box {
    background-color: #ffffff;
  }
  .top-title {
    font-size: 14px;
    border-bottom: 1px solid #ebeef5;
    padding: 15px 20px 15px 20px;
    span {
      display: inline-block;
      margin-right: 10px;
      width: 4px;
      height: 15px;
      background-color: #409eff !important;
      border-radius: 4px;
    }
  }
  .bottom-button {
    text-align: center;
    padding-bottom: 20px;
  }
</style>
